import { isIOS } from 'mobile-device-detect';

// 공통 인터페이스
export interface IRequest {
  method: string;
  args?: any;
}

export interface IReceive {
  eventName: number;
  callback: any;
}

export type TBridgeMap = (
  bridge: any,
  errorHandler: () => void,
  versionChecker: any,
) => {
  getParamInfo: (params: any) => any;
  getAppVersion: () => { version: string };
  openNativeWebView: ({
    url,
    title,
    closeType,
  }: {
    url: string;
    title?: string;
    closeType?: 'B' | 'N';
  }) => void;
  openExternalBrowser: (obj: { url: string }) => void;
  close: () => void;
  goNativeMain: () => void;

  requestAddService?: (obj: {
    type: string;
    url: string;
    noneMemberUrl?: string;
    freeMemberUrl?: string;
    paidMemberUrl?: string;
    needMoveAfterJoin?: boolean;
  }) => void;
  requestAuthCheck?: (obj: { pisAppToken: string }) => void;
  requestCustomerInfo?: (obj: { thirdLoanYn: string }) => void;
  onClickNativeBackKey?: (callback: () => void) => void;
  onReceiveCustomerInfo?: (callback: () => void) => void;
  onReceiveAuthCheck?: (callback: () => void) => void;
  requestUserCertIssuanceStatus?: () => void;
  onReceiveUserCertIssuanceStatus?: (callback: () => void) => void;
  requestUserCertIssuance?: () => void;
  onReceiveUserCertIssuance?: (callback: () => void) => void;
  requestCertSignStandby?: () => void;
  onCertSignResult?: (callback: () => void) => void;
};

export const withErrorHandler = (
  fn: () => void,
  { result }: { result: boolean },
  errorHandler?: () => void,
) => {
  if (result) {
    fn();
  } else {
    errorHandler && errorHandler();
  }
};

export interface IVersionDic {
  [index: string]: { version: string; tag?: string }[];
}

export const createVersionChecker = (version: any, versionDic: IVersionDic) => {
  const checkVersion = (method: string) => {
    const versionsByMethod = versionDic[method];

    let diffVersion = '';
    let currentVersion = version.replace(/\./g, '');

    return (tag: any) => {
      if (tag) {
        diffVersion =
          versionsByMethod
            .find((item) => item.tag === tag)
            ?.version?.replace(/\./g, '') || '';
      } else {
        const sortedVersionByMethod = [...versionsByMethod].sort(
          (a: any, b: any) =>
            a.version.replace(/\./g, '') - b.version.replace(/\./g, ''),
        );
        diffVersion = sortedVersionByMethod[0].version?.replace(/\./g, '');
      }

      return {
        result: currentVersion >= diffVersion,
        method,
        tag,
      };
    };
  };

  const rObj: any = {};
  for (let key in versionDic) {
    rObj[key] = checkVersion(key);
  }
  return rObj;
};

export enum OS {
  IOS,
  AOS,
}

export const os = isIOS ? OS.IOS : OS.AOS;
